import { Link } from "react-router-dom";
import { Phone, Clock, MapPin } from "lucide-react";
import { NAV_LINKS, PHONE_DISPLAY, PHONE_LINK, HOURS, ZONE } from "../data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-black text-white">
    <div className="max-w-screen-xl mx-auto px-4 md:px-8 py-16 md:py-24 grid gap-12 md:grid-cols-12">
      <div className="md:col-span-4">
        <img
          src="/logo-transparent.png"
          alt="Quercy Nuisibles"
          className="h-40 w-auto -ml-2"
        />
        <p className="text-sm text-neutral-400 mt-6 max-w-xs">
          Lutte professionnelle contre les nuisibles. Basés à Cahors, actifs
          dans tout le Lot et les départements limitrophes.
        </p>
      </div>

      <div className="md:col-span-3">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#E50914]">
          Contact
        </p>
        <a
          href={PHONE_LINK}
          data-testid="footer-phone-link"
          className="mt-4 flex items-center gap-3 text-lg font-semibold transition-colors duration-300 hover:text-[#E50914]"
        >
          <Phone className="h-4 w-4" /> {PHONE_DISPLAY}
        </a>
        <p className="mt-4 flex items-start gap-3 text-sm text-neutral-400">
          <Clock className="h-4 w-4 mt-0.5 shrink-0" /> {HOURS}
        </p>
        <p className="mt-3 flex items-start gap-3 text-sm text-neutral-400">
          <MapPin className="h-4 w-4 mt-0.5 shrink-0" /> {ZONE}
        </p>
      </div>

      <div className="md:col-span-2">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#E50914]">
          Navigation
        </p>
        <nav className="mt-4 flex flex-col gap-2">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              data-testid={`footer-${link.testId}`}
              className="text-sm font-semibold uppercase tracking-[0.1em] text-neutral-300 transition-colors duration-300 hover:text-[#E50914]"
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>

      <div className="md:col-span-3">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#E50914]">
          Urgence nuisibles
        </p>
        <p className="mt-4 text-sm text-neutral-400">
          Un nid de frelons, des rats dans les murs, des chenilles
          processionnaires dans vos pins ? N'attendez pas.
        </p>
        <Link
          to="/contact"
          data-testid="footer-devis-button"
          className="mt-6 inline-block bg-[#E50914] text-white px-6 py-3 text-sm font-semibold uppercase tracking-[0.1em] transition-colors duration-300 hover:bg-white hover:text-black"
        >
          Demander un devis
        </Link>
      </div>
    </div>

    <div className="border-t border-neutral-800">
      <div className="max-w-screen-xl mx-auto px-4 md:px-8 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-2">
        <p className="text-xs text-neutral-500">
          © 2026 Quercy Nuisibles — Cahors, Lot (46). Tous droits réservés.{" "}
          Propulsé par{" "}
          <a
            href="https://equinoxe.studio"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-equinoxe-link"
            className="underline decoration-neutral-600 underline-offset-2 transition-colors duration-300 hover:text-[#E50914] hover:decoration-[#E50914]"
          >
            Equinoxe Studio
          </a>
        </p>
        <Link
          to="/mentions-legales"
          data-testid="footer-legal-link"
          className="text-xs uppercase tracking-[0.2em] text-neutral-500 transition-colors duration-300 hover:text-[#E50914]"
        >
          Mentions légales
        </Link>
        <p className="text-xs uppercase tracking-[0.2em] text-neutral-500">
          Cibler · Éliminer · Protéger
        </p>
      </div>
    </div>
  </footer>
);
